<div class="content">
  <h2>{{ errorBarMessage | translate }}</h2>
  <button [disabled]="isLoading" (click)="onRestartSurvey()">
    {{ 'surveyPreviewEnding.restart' | translate }}
  </button>
</div>
